import React from 'react';
import PropTypes from 'prop-types';

import Tabs from '@molecules/Tabs';
import ArrowRightIcon from '@icons/ArrowRightIcon';
import colors from '@general/colors';
import { LinkSmall, H4 } from '@styled';

import FeaturedPropertiesMatches from '../../../_organisms/FeaturedPropertiesMatches';
import SearchPropertiesSaved from '../../../searches/SearchPropertiesSaved';
import { SearchModeContext } from '../../../../../../algolia-search/js/context/searchContext';
import SearchPropertiesActive from '../../../searches/SearchPropertiesActive';

const FeaturedProperties = ({ eventCode }) => (
    <div>
        <H4 className="mb-1.25rem">Explore Featured Property Listings</H4>

        <Tabs defaultActiveTab="matches">
            <div tabKey="matches" title="My Matches">
                <FeaturedPropertiesMatches eventCode={eventCode} />
            </div>

            <div tabKey="saved" title="Saved Properties">
                <SearchPropertiesSaved
                    additionalFilters={`events:${eventCode}`}
                    hitsPerPage={6}
                    parentView="Events"
                    resultsPerRow={3}
                    showPagingToolbar
                    NoResultsText={() => (
                        <>Looks like none of your saved properties are being featured at this event.</>
                    )}
                />
            </div>
            <div tabKey="all" title="All Properties">
                <div className="align-items-center d-block d-md-flex justify-content-end mb-2rem">
                    <LinkSmall
                        href="/my-icsc/properties/find"
                        className="align-items-center cursor-pointer d-flex text-primary whitespace-nowrap"
                    >
                        <span className="mr-0.5rem">See Full Property List</span>
                        <ArrowRightIcon color={colors.primary} />
                    </LinkSmall>
                </div>
                <SearchModeContext.Provider value={{ showFilters: false }}>
                    <SearchPropertiesActive
                        defaultViewType="card"
                        displayMap
                        updateSearchStateUrl={false}
                        additionalFilters={`events:${eventCode}`}
                        initialSearchState={{
                            refinementList: {
                                events: [eventCode],
                            },
                        }}
                    />
                </SearchModeContext.Provider>
            </div>
        </Tabs>
    </div>
);

FeaturedProperties.propTypes = {
    eventCode: PropTypes.string.isRequired,
};

export default FeaturedProperties;
